'use client';

import {useEffect} from 'react';

/** Adds an event listener to detect clicking-out of the givin element or elements. */
export function useClickOut<T extends HTMLElement | null>(
  element: React.RefObject<T> | React.RefObject<T>[],
  listen: boolean,
  callback: () => void
) {
  useEffect(() => {
    function handler(event: MouseEvent) {
      for (const _element of Array.isArray(element) ? element : [element]) {
        if (
          _element.current &&
          _element.current.contains(event.target as Element)
        )
          return;

        callback();
      }
    }

    document[listen ? 'addEventListener' : 'removeEventListener'](
      'click',
      handler as EventListener
    );

    return () => document.removeEventListener('click', handler);
  }, [listen]); // eslint-disable-line react-hooks/exhaustive-deps
}
